import React, { useMemo } from 'react';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { WrapperCommon } from '../../../../common/cell-wrapper';
import { TagListWrapper } from '../../../../common/ui/tag-list-wrapper';
import type { VersionReadProps } from './types';

export const VersionRead = ({ selectedVersions, isEditable }: VersionReadProps) => {
	const [version, count] = useMemo(() => {
		if (Array.isArray(selectedVersions)) {
			const [firstVersion, ...others] = selectedVersions ?? [];
			return [firstVersion?.name, others.length];
		}
		if (selectedVersions != null) {
			return [selectedVersions.name, 0];
		}
		return [undefined, 0];
	}, [selectedVersions]);

	if (version == null) {
		return null;
	}

	return (
		<WrapperCommon>
			<TagListWrapper isEditable={isEditable}>
				<SimpleTag text={version} />
				{count > 0 && <SimpleTag text={`+${count}`} />}
			</TagListWrapper>
		</WrapperCommon>
	);
};
